import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import zhCN from "antd/es/locale/zh_CN";
import PageMain from "./pages/main/main";
import PageLogin from "./pages/user/login";
import { ConfigProvider } from "antd";
import "./components/Style/style.scss";
import ScrollToTop from "./components/ScrollToTop";
import PageQuestionView from "./pages/questions/view";
import PageHomeworkMain from "./pages/homework/main";
import PageHomeworkReview from "./pages/homework/review";
import PageQuestionMain from "./pages/questions/main";
import PageHomeworkDetailPage from "./pages/homework/detail";
import BaiduTrack from "./components/BaiduTrack";
import PageDashBoardDaily from "./pages/dashboard/daily";
import PageDashBoardSection from "./pages/dashboard/section";
import PageClasses from "pages/classs/main";
import PageExamMain from "./pages/exam/main";
import PageExamAdd from "./pages/exam/addExam";
import PageExamReview from "./pages/exam/reviewExam";
import PageLunWenReview from "./pages/exam/reviewLunWen";
import PageLunWenAdd from "./pages/exam/addLunWen";
import PageExamReviewList from "./pages/exam/reviewListExam";
import PageOralReviewList from "./pages/exam/reviewListOral";
import PageReviewStudentExam from "pages/exam/reviewStudentExam";
import PageNoticeMain from "pages/notice/main";
import PageEditHomework from "./pages/homework/edit";
import PageCourseDetail from "./pages/CourseDetail";
import PageTeachLogDetail from "./pages/TeachLogDetail";
import PageCourse from "./pages/course/prepare";
import CourseProjection from "./pages/CourseProjection";
import CourseList from "./pages/course/list";
import PageAnalyse from "./pages/course/Analyse";
import PageLiveRecord from "./pages/course/LiveRecord";
import PageInvitatinCode from "pages/course/InvitationCode";
import PageSuperviseList from "pages/exam/supervise";
import ResourcePool from "pages/ResourcePool/pages/Index/index";
import PageAnswerStore from "pages/answerStore/main";
import Evaluate from "./pages/Evaluate";
import EvaluateExam from "./pages/exam/evaluateExam";
import InvigilationLog from "./pages/exam/invigilationLog";
import PageScore from "./pages/course/Score";
import Chat from "./pages/Chat";
import LayoutMain from "./components/LayoutMain";
import Boundary from "./components/Boundary";
import ChangePwd from "./pages/user/changePwd";
import { LayoutRoute } from "./components/LayoutRoute";
import LoginConsole from "./pages/user/loginConsole";
import AskTeacher from "./pages/AskTeacher";
import My from "./pages/My";
import MyEvaDeital from "./pages/My/List/Deital";
import RedictLogin from "./pages/user/RedictLogin";

const App = () => {
    return (
        <ConfigProvider locale={zhCN}>
            <Boundary>
                <Router>
                    <ScrollToTop />
                    <BaiduTrack />

                    <Switch>
                        <LayoutRoute
                            exact
                            path="/"
                            component={PageMain}
                            layout={LayoutMain}
                        />

                        <Route exact path="/login" component={PageLogin} />

                        <Route
                            exact
                            path="/login/console"
                            component={LoginConsole}
                        />

                        <Route exact path="/redict" component={RedictLogin} />

                        <Route exact path="/changepwd" component={ChangePwd} />

                        {/*课程管理系列页面, 注意, 内含子路由*/}
                        <LayoutRoute
                            path="/course/detail/:weekTimeId?/:batchNo?/:courseNo?/:courseSeq?/"
                            component={PageCourseDetail}
                            layout={LayoutMain}
                        />

                        {/*课程投屏系列页面, 注意, 内含子路由*/}
                        <LayoutRoute
                            path="/course/projection/:weekTimeId"
                            component={CourseProjection}
                            layout={LayoutMain}
                        />

                        {/*教学日志系列页面, 注意, 内含子路由*/}
                        <LayoutRoute
                            path="/course/teachlog/:weekTimeId"
                            component={PageTeachLogDetail}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/:courseVersionCode/:courseName"
                            component={PageCourse}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/list"
                            component={CourseList}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/:courseNo/:courseSeq/analyse/:id?"
                            component={PageAnalyse}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/:courseNo/:courseSeq/:courseName/:channelId/liveRecord"
                            component={PageLiveRecord}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/:courseNo/:courseSeq/:courseName/:teacherName/invitatinCode"
                            component={PageInvitatinCode}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/course/:batchNo/:courseNo/:courseSeq/score"
                            component={PageScore}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/evaluate/:id"
                            component={Evaluate}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/questions"
                            component={PageQuestionMain}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/my"
                            component={My}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/my/detail/:evaluationId"
                            component={MyEvaDeital}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/question/:id"
                            component={PageQuestionView}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/homework"
                            component={PageHomeworkMain}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/homework/edit/:courseNo/:courseSeq/:weekTime/:week/:section/:continunity/:weekTimeId"
                            component={PageEditHomework}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/homework/review/list/:courseNo/:courseSeq/:weekTime/:week/:section/:continunity/:weekTimeId/:sort?"
                            component={PageHomeworkReview}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/homework/review/detail/:paperId/:studentId"
                            component={PageHomeworkDetailPage}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/dashboard/daily"
                            component={PageDashBoardDaily}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/dashboard/section/:date/:section"
                            component={PageDashBoardSection}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/classes/:weekTimeId/:batchNo/:courseNo/:courseSeq/:tab"
                            component={PageClasses}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/evaluation/:batchNo/:examId/:courseNo/:courseSeq"
                            component={EvaluateExam}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/main/:tab?"
                            component={PageExamMain}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            path="/exam/invigilation"
                            component={InvigilationLog}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/add/:examId/:readonly"
                            component={PageExamAdd}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/thesis/add/:examId/:readonly"
                            component={PageLunWenAdd}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/preview/:examId/:examType"
                            component={PageReviewStudentExam}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/review/:examId"
                            component={PageExamReviewList}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/oral/review/:examId"
                            component={PageOralReviewList}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/review/detail/:examId/:paperId/:studentId/:studentNo/:ban"
                            component={PageExamReview}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/thesis/review/detail/:examId/:paperId/:studentId"
                            component={PageLunWenReview}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/exam/supervise/:examId"
                            component={PageSuperviseList}
                            layout={LayoutMain}
                        />

                        {/*资源中心*/}
                        <LayoutRoute
                            exact
                            path="/resource"
                            component={ResourcePool}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            path="/notice"
                            component={PageNoticeMain}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            exact
                            path="/answerStore"
                            component={PageAnswerStore}
                            layout={LayoutMain}
                        />

                        <LayoutRoute
                            path="/askTeacher"
                            component={AskTeacher}
                            layout={LayoutMain}
                        />

                        {/*聊天*/}
                        <LayoutRoute
                            exact
                            path="/chat"
                            component={Chat}
                            layout={LayoutMain}
                        />
                    </Switch>
                </Router>
            </Boundary>
        </ConfigProvider>
    );
};

export default App;
